import {
  AttachMoney,
  Description,
  History as HistoryIcon,
  Percent,
} from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

import { formatMoney } from '../../../../functions/utils';
import InfoRow from './InfoRow';

const formatRate = (rate: string | null): string | null => {
  if (!rate) return null;
  return `${rate}%`;
};

import { DocumentConciliationRateHistory } from './types';

interface SummarySectionProps {
  operationDate: string | null;
  businessRate: string | null;
  documentAmount: number | null;
  interestCost: number | null;
  paymentDate: string | null;
  advance: number | null;
  morosityRate: number | null;
  netAmount: number | null;
  days: number | null;
  invoiceAmount: number | null;
  fundName: string | null;
  documentId?: string | null;
  rateHistory?: DocumentConciliationRateHistory | null;
  onHistoryLoaded?: (history: DocumentConciliationRateHistory) => void;
}

const SummarySection: React.FC<SummarySectionProps> = ({
  operationDate,
  businessRate,
  documentAmount,
  interestCost,
  paymentDate,
  advance,
  morosityRate,
  netAmount,
  days,
  invoiceAmount,
  fundName,
  documentId,
  rateHistory,
  onHistoryLoaded,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(156, 39, 176, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(156, 39, 176, 0.15)',
          mt: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'purple',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Resumen Operación
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InfoRow
            label="Fecha Operación"
            value={operationDate}
            maxLength={40}
            icon={<Description sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Tasa negocio"
            value={formatRate(businessRate)}
            maxLength={40}
            icon={<Percent sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Tasa morosidad"
            value={formatRate(morosityRate?.toString() || null)}
            maxLength={40}
            icon={<Percent sx={{ fontSize: '0.8rem', color: 'purple' }} />}
            actionIcon={<HistoryIcon sx={{ fontSize: '1rem' }} />}
            actionTooltipText="Historial de tasas aplicadas"
            documentId={documentId || undefined}
            rateHistory={rateHistory}
            onHistoryLoaded={onHistoryLoaded}
          />
          <InfoRow
            label="Monto Original"
            value={invoiceAmount ? formatMoney(invoiceAmount) : null}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Anticipo"
            value={formatRate(advance?.toString() || null)}
            maxLength={40}
            icon={<Percent sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Monto Retenido"
            value={
              documentAmount && netAmount
                ? formatMoney(documentAmount - (netAmount || 0))
                : null
            }
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InfoRow
            label="Fecha de vencimiento"
            value={paymentDate}
            maxLength={40}
            icon={<Description sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Días"
            value={days?.toString() || null}
            maxLength={40}
            icon={<Description sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Fondo"
            value={fundName || null}
            maxLength={40}
            icon={<Description sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Monto Documento"
            value={documentAmount ? formatMoney(documentAmount) : null}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Monto Anticipado"
            value={netAmount ? formatMoney(netAmount) : null}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Costo de Interés"
            value={interestCost ? formatMoney(interestCost) : null}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SummarySection;
